import { Card, Divider } from '@material-ui/core'
import { useEffect } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { getProjectRequestsDetails } from '../../../actions/projectActions'
import { calcTotalCost } from '../../../helpers/Helpers'
import { useQuoteCalculator } from '../../../hooks/useQuoteCalculator'
import HelpTooltip from '../../Tooltip/HelpTooltip'
import LineItem from './LineItem'
import MyCareDiscount from './MyCareDiscount'
import PromoCode from './PromoCode'

const TotalCost = ({ interactive = true }) => {
  const dispatch = useDispatch()

  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { projectRequests } = useSelector(
    (state: RootStateOrAny) => state.projectRequestsDetails
  )
  const { success: partUpdateSuccess } = useSelector(
    (state: RootStateOrAny) => state.partUpdate
  )

  const total = useQuoteCalculator(projectRequests)

  useEffect(() => {
    if (project._id) {
      dispatch(getProjectRequestsDetails(project._id))
    }
  }, [project, dispatch, partUpdateSuccess])

  return (
    <>
      <div className="flex align-center">
        <h5 className="m-b-24">
          Estimate
          <HelpTooltip
            title={
              <div className="p-b-12">
                This is an auto-generated estimate from the details provided and
                is not to be used as a final quote for services.
              </div>
            }
          />
        </h5>
      </div>

      <Card className="p-t-24 p-b-24 p-l-32 p-r-32">
        {projectRequests !== undefined &&
          projectRequests.length > 0 &&
          projectRequests.map((request: IRequest, index: number) => (
            <LineItem key={index} request={request} />
          ))}

        {project && Object.keys(project.addOnServices).length !== 0 && (
          <>
            {project.addOnServices.onsiteDebugging && (
              <div className="flex space-between">
                <div className="fs14 bold">Onsite debugging</div>
                <div className="fs14 bold">TBD*</div>
              </div>
            )}

            {project.addOnServices.correlationGRR && (
              <div className="flex space-between">
                <div className="fs14 bold">Correlation GR+R</div>
                <div className="fs14 bold">TBD*</div>
              </div>
            )}

            {project.addOnServices.fixtureDesign && (
              <div className="flex space-between">
                <div className="fs14 bold">Fixture design</div>
                <div className="fs14 bold">TBD*</div>
              </div>
            )}

            {project.addOnServices.premiumSupport && (
              <div className="flex space-between">
                <div className="fs14 bold">Premium support</div>
                <div className="fs14 bold">TBD*</div>
              </div>
            )}

            {project.addOnServices.classroomOrVirtualSupport && (
              <div className="flex space-between">
                <div className="fs14 bold">Classroom or virtual training</div>
                <div className="fs14 bold">TBD*</div>
              </div>
            )}

            {project.addOnServices.customOnsiteTraining && (
              <div className="flex space-between">
                <div className="fs14 bold">Custom onsite training</div>
                <div className="fs14 bold">TBD*</div>
              </div>
            )}
          </>
        )}

        {interactive && <Divider className="m-t-24 m-b-24" />}

        <PromoCode interactive={interactive} />

        {interactive && <Divider className="m-t-24 m-b-24" />}

        <MyCareDiscount interactive={interactive} />

        {interactive && <Divider className="m-t-24 m-b-24" />}

        <div className="flex space-between">
          <h5 className="m-b-0 m-t-8">Total</h5>
          <h5 className="m-b-0 m-t-8">
            {isNaN(Number(total))
              ? 'TBD'
              : calcTotalCost(
                  Number(total),
                  project.isMyCareMember,
                  project.discountCodes.reduce(
                    (acc: number, cur: PromoCode) => {
                      return acc + cur.value
                    },
                    0
                  )
                )}
          </h5>
        </div>

        {isNaN(Number(total)) && (
          <div className="primary fs10 m-t-16">
            We are not be able to give an accurate cost estimate because one or
            more of your requests is missing critical information.
          </div>
        )}

        {(project.addOnServices.correlationGRR ||
          project.addOnServices.premiumSupport ||
          project.addOnServices.classroomOrVirtualSupport ||
          project.addOnServices.customOnsiteTraining) && (
          <div className="primary fs10 m-t-16">
            *Total cost does not reflect cost of Add-On Services that are TBD.
          </div>
        )}
      </Card>
    </>
  )
}

export default TotalCost
